<div class="product-card w-full">
    <div class="product-header">
        <h2 class="product-title">{{product.name}}</h2>
        <img [src]="product.img" [alt]="'Imagen del producto: ' + product.id" class="product-img">

    </div>

    <div class="product-info">
        <div class="info-section">
            <strong class="info-label">Descripción: </strong>
            <p class="info-text">{{ product.description }}</p>
        </div>

        <div class="info-section">
            <strong class="info-label">Etiquetas: </strong>
            <p class="info-text">{{product.tags}}</p>
        </div>

        <div class="info-section">
            <strong class="info-label">Familia: </strong>
            <p class="info-text">{{product.family}}</p>
        </div>

        <div class="info-section">
            <strong class="info-label">Id Categoria: </strong>
            <p class="info-text">{{product.idCategory}}</p>
        </div>

        <div class="info-section">
            <strong class="info-label">Creado en: </strong>
            <p class="info-text">{{product.createdAt}}</p>
        </div>
    </div>
</div>
